import React, {useState} from 'react';
import styled from "styled-components";
import Icn from "./Icn";

const WrapperStyled = styled.div`
    position: absolute;
    right: 0;
`;

const CopyStyled = styled.div`
    width: fit-content;
    padding: 3px 3px;
    line-height: 1;
    font-size: 13px;
    cursor: pointer;
    font-weight: 400;
    
    svg{
        width: 20px;
        height: 20px;
    }
    
    &:hover{
        
    }
`;

const CopyToClipboard = ({textToCopy}) => {
    const [copied, s_copied] = useState(false);


    const handleCopyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            s_copied(true);
            setTimeout(() => {
                s_copied(false);
            }, 1500); // Reset copied state after 1.5 seconds
        } catch (error) {
            console.error('Failed to copy:', error);
        }
    };

    return (
        <WrapperStyled>

            <CopyStyled
                onClick={() => handleCopyToClipboard(textToCopy)}
            >
                {copied && (
                    <span>Copied</span>
                )}
                {!copied && (
                    <Icn style={{}}>contentCopyIcon</Icn>
                )}
            </CopyStyled>
        </WrapperStyled>
    );
};

export default CopyToClipboard;